<div class="row mb-3">
    <div class="col">
        <app-question-bank-question-add [isEditMode]="isEditMode"
                                        [questionBankId]="questionBankId"
                                        (questionBankQuestionAdded)="onQuestionBankQuestionAdded($event)">
        </app-question-bank-question-add>
    </div>
</div>

<section class="panel">
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-hover mb-none">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Question Title</th>
                        <th>Audit Type</th>
                        <th class="text-center">Is Mandatory</th>
                        <th class="text-center">Order</th>
                        <th class="text-center" width="10%">Action</th>
                    </tr>
                </thead>
                <tbody cdkDropList (cdkDropListDropped)="drop($event)">
                    <tr *ngFor="let questionBankQuestion of questionBankQuestions;index as i" cdkDrag class="draggable">
                        <td>{{i+1}}</td>
                        <!--<td title="{{questionBankQuestion.questionTitle | htmlToText}}" data-toggle="tooltip">{{questionBankQuestion.questionTitle | htmlToText | truncate:125}}</td>-->
                        <td>{{questionBankQuestion.questionTitle | htmlToText | truncate:250}}</td>
                        <td>{{questionBankQuestion.auditType}}</td>
                        <td class="text-center">
                            <ng-container *ngIf="!isEditMode">
                                <span *ngIf="questionBankQuestion.isMandatory"><i class="fas fa-check"></i></span>
                                <span *ngIf="!questionBankQuestion.isMandatory"><i class="fas fa-times"></i></span>
                            </ng-container>
                            <ng-container *ngIf="isEditMode">
                                <!--<input type="checkbox" id="isActive" name="isActive" class="form-control" (change)="toggleMandatory(questionBankQuestion.id)" appToggle />-->
                                <button type="button" class="btn btn-text bg-transparent p-0" (click)="toggleMandatory(questionBankQuestion)">
                                    <span class="text-sm fas fa-toggle-on text-primary" *ngIf="questionBankQuestion.isMandatory"></span>
                                    <span class="text-sm fas fa-toggle-off text-muted" *ngIf="!questionBankQuestion.isMandatory"></span>
                                </button>
                            </ng-container>
                        </td>
                        <td class="text-center">{{questionBankQuestion.zOrder}}</td>
                        <td class="actions text-center">
                            <ng-container *ngIf="isEditMode">
                                <a (click)="selectedQuestionBankQuestionId=questionBankQuestion.id; confirmation.showMessage()" title="Delete Question" class="mb-1 mt-1 me-2" *ngIf="isEditMode"><i class="fas fa-trash text-danger"></i></a>
                            </ng-container>
                            <ng-container *ngIf="isEditMode">
                                <a class="" [routerLink]="['/question', questionBankQuestion.questionId]" title="Edit Question">
                                    <i class="fas fa-pencil-alt text-primary"></i>
                                </a>
                            </ng-container>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>

<app-confirmation-message #confirmation (confirmationClicked)="deleteQuestionBankQuestion()"
                          [title]="'Confirmation'"
                          [message]="'Are you sure you want to remove this question?'">
</app-confirmation-message>
